module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/pass-window-e7c6df.svg";